module.exports = __webpack_public_path__ + "img/garantia.be783d3c.svg";